import React from 'react';
import c from 'classnames';
import { createUseStyles } from 'react-jss';
import { useTabsContext } from './TabsContext';
import { Colours, FontWeights } from '../../tokens';
import boxShadows from '../../tokens/boxShadows';
const useStyles = createUseStyles(() => ({
    root: {
        border: 0,
        backgroundColor: 'transparent',
        color: Colours.primary,
        fontSize: 14,
        fontWeight: FontWeights.Regular,
        borderRadius: 10,
        padding: '8px 24px',
        cursor: 'pointer',
        '&:hover': {
            backgroundColor: Colours.quarternary,
            boxShadow: boxShadows.standard,
        },
    },
    active: {
        backgroundColor: Colours.white,
        boxShadow: boxShadows.standard,
        '&:hover': {
            backgroundColor: Colours.white,
            boxShadow: boxShadows.standard,
        }
    },
}));
function Tab({ children, value, onClick = () => { }, }) {
    const [tab, setTab] = useTabsContext();
    const classes = useStyles();
    const onTabClick = () => {
        onClick();
        setTab(value);
    };
    return (React.createElement("button", { type: "button", role: "tab", onClick: onTabClick, tabIndex: 0, className: c(classes.root, tab === value && classes.active) }, children));
}
export default Tab;
//# sourceMappingURL=Tab.js.map